import { NotFound } from 'components/common/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ShabuSukiyaki from './page/ShabuSukiyaki';

export default function ShabuSukiyakiFeature() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={`${path}/`}>
          <ShabuSukiyaki />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
}
